const TechnicalAnalysisPage = () => {
    return <div>Technical Analysis Page</div>
}

export default TechnicalAnalysisPage;